import { BookData } from 'src/interfaces'

export const getBookCoverImageUrl = (book?: BookData | null): string => {
	if (!book) return ''

	const record = book as BookData & { thumbnails?: string[] }
	return record.cover_image?.trim() || record.thumbnails?.[0]?.trim() || ''
}

export const getBookTitle = (book?: BookData | null): string => {
	return book?.title?.trim() || ''
}
